export enum GlobalRole {
    Admin = 'Admin',
    RoomAdmin = 'RoomAdmin',
    TemplateAdmin = 'TemplateAdmin',
    Host = 'Host',
    ProjectAdmin = 'ProjectAdmin',
    ProjectOwner = 'ProjectOwner'
}